import TipoProcessoService from '../_services/TipoProcessoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { tipoProcessoModel } from './../_model/index'

const state = {
  loading: false,
  loadingStore: false,
  dropDownTipoProcessos: [],
  tipoProcessos: [],
  tipoProcessoSelecionado: undefined,
  erros: '',
}

const getters = {
  GET_TIPOPROCESSOS : (state) => state.tipoProcessos,
  GET_DROPDOWN: state => state.dropDownTipoProcessos,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  TIPOPROCESSO_SELECTED : (state, { tipoProcesso }) => {
    state.tipoProcessoSelecionado = Object.assign({}, tipoProcesso)
  },

  SET_TIPOPROCESSOS : (state, { tipoProcessos }) => {
    state.tipoProcessos = tipoProcessos
  },

  SET_DROPDOWN : (state, tipoProcessos) => {
    state.dropDownTipoProcessos = tipoProcessos
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.tipoProcessoSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await TipoProcessoService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = [{value: '', text:''}]
        var obj = response.data.tipoprocessos
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].descricao }
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_TIPOPROCESSOS : async ({ commit }) => {
      commit('SET_TIPOPROCESSOS', { tipoProcessos : []})
      commit('ERASE_ERROS')
      await TipoProcessoService.getTipoProcessos()
      .then(response => {
        if (response.data.status) {
          commit('SET_TIPOPROCESSOS', { tipoProcessos : response.data.tipoprocessos })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_TIPOPROCESSO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await TipoProcessoService.getTipoProcesso(id)
    .then(response => {
      if (response.data.status) {
        commit('TIPOPROCESSO_SELECTED', { tipoProcesso : response.data.tipoprocesso })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_TIPOPROCESSO : async ({ commit, dispatch }, tipoProcesso) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!tipoProcesso.id || !(tipoProcesso.id > 0)) { 
        var response = await TipoProcessoService.postTipoProcesso(tipoProcesso)
      } else {
        var response = await TipoProcessoService.putTipoProcesso(tipoProcesso.id, tipoProcesso)
      }

      if (response.data.status) {
        commit('TIPOPROCESSO_SELECTED', { tipoProcesso : response.data.tipoprocesso })
        dispatch('GET_TIPOPROCESSOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_TIPOPROCESSO : async ({ commit, dispatch }, tipoProcesso) => {
    commit('ERASE_ERROS')
    try {
      var response = await TipoProcessoService.deleteTipoProcesso(tipoProcesso.id)

      if (response.data.status) {
        await dispatch('GET_TIPOPROCESSOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  TIPOPROCESSO_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_TIPOPROCESSO', id)
    } else {
      var obj = new tipoProcessoModel.tipoProcesso()
      await commit('TIPOPROCESSO_SELECTED', { tipoProcesso: obj })
    }    
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/TipoProcesso/_store/index.js